import React from 'react'
import frLocale from 'date-fns/locale/fr';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
import { Box } from '@mui/system';
import { InputAdornment } from '@mui/material';

import {makeStyles} from '@mui/styles'



const DatePicker_Dsas = ({ className, name, value, label, onChange, isBorder = true, sx = {}, disabled }) => {
    const useStyles = makeStyles(() => ({
      noBorder: {
        borderWidth: isBorder ? '1px!important' : "0px!important",
      },
    }));
  
    const classes = useStyles();
  
    // Si value est null ou undefined, passer null au DatePicker pour le garder vide
    const dateValue = value ?? null;
  
    return (
      <Box className={className} sx={sx}> {/* Appliquer le `sx` ici */}
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={frLocale}>
          <DatePicker
            fullWidth
            label={label}
            disabled={disabled}
            value={dateValue}
            name={name}
            onChange={onChange}
            renderInput={(params) => (
              <TextField 
              fullWidth
                {...params}
                error={false}  // Empêcher le rouge si la date est vide
                helperText=""  // Supprimer le texte d'aide
                sx={sx} // Appliquer le style `sx` au TextField pour qu'il soit responsive
              />
            )}
          />
        </LocalizationProvider>
      </Box>
    );
  }

export default DatePicker_Dsas